import { IconWithText } from 'common/icon/icon-with-text.js';

interface IProps {
  type: '1000' | '2000';
  wind: string;
}

export const DisplayForecastWind = ({ type, wind }: IProps) => (
  <IconWithText icon="wind" classes="IconWithText--responsive">
    <p className="u-textBold h4 u-mT-0 u-mB-0">Wind at {type} metres</p>
    <p className="u-textRegular u-mT-0 u-mB-sm">{wind}</p>
  </IconWithText>
);
